import { useSyncExternalStore } from 'react';
import guardAuthService from '../services/guardAuth.service';

const GUARD_AUTH_EVENT = 'guard-auth-change';

function subscribe(callback: () => void) {
  window.addEventListener(GUARD_AUTH_EVENT, callback);
  window.addEventListener('storage', callback);
  return () => {
    window.removeEventListener(GUARD_AUTH_EVENT, callback);
    window.removeEventListener('storage', callback);
  };
}

export function useGuardAuthenticated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => guardAuthService.isAuthenticated(),
    () => false,
  );
}

export { GUARD_AUTH_EVENT };
